import styled from "styled-components";

export const PaymentMethodsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  padding: 2rem;

  color: var(--secondary-color);
`;

export const PaymentMethodsCard = styled.div`
  padding: 0.5rem 1.5rem;
  background-color: #ffffff;
  border-radius: 8px;
`;

export const PaymentTypeRow = styled.button`
  display: flex;
  align-items: center;
  gap: 2rem;

  width: 100%;
  max-width: 36rem;
  padding: 1.5rem;

  border: none;
  background-color: transparent;
  color: #7f7f7f;

  cursor: pointer;

  > * {
    height: 4.375rem;
  }

  > img {
    aspect-ratio: 1/1;
    object-fit: contain;
  }

  > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    width: 100%;

    h2 {
      margin: 0;
    }

    img {
      height: 1.875rem;
      margin-top: auto;
    }
  }

  & + & {
    border-top: 1px solid #d8d8d8;
  }
`;
